import { render, staticRenderFns } from "./WorkflowHistoryItem.vue?vue&type=template&id=68ef0790&scoped=true&"
import script from "./WorkflowHistoryItem.vue?vue&type=script&lang=ts&"
export * from "./WorkflowHistoryItem.vue?vue&type=script&lang=ts&"
import style0 from "./WorkflowHistoryItem.vue?vue&type=style&index=0&id=68ef0790&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68ef0790",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
